import { render, staticRenderFns } from "./AyudaPagos.vue?vue&type=template&id=3dc46fe6&scoped=true"
import script from "./AyudaPagos.vue?vue&type=script&lang=js"
export * from "./AyudaPagos.vue?vue&type=script&lang=js"
import style0 from "./AyudaPagos.vue?vue&type=style&index=0&id=3dc46fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc46fe6",
  null
  
)

export default component.exports